// extracted by mini-css-extract-plugin
module.exports = {"sideBanner":"SideBanner_sideBanner__xPUyD","sideBanner--left":"SideBanner_sideBanner--left__2JzbT","sideBanner--right":"SideBanner_sideBanner--right__3Gr_M"};